<template>
    <modal :modal-id="modalId"
                     :title="modalTitle"
                     :preloader="preloader"
                     class="pay-modal"
                     @submit="submit"
                     @close-modal="closeModal">
        <template slot="body">
            <app-overlay-loader v-if="preloader"/>

            <div v-if="this.payThis == 0" class="text-center">
                <br><br><br><br>
                <h2>Aktuálně využíváte zkušební verzi.</h2><br>Na této stránce najdete v následujících týdnech platební formulář pro platbu kartou.<br><br><br><br>
            </div>


            <div class="row" v-if="this.payThis == 1 && this.lockedScreenTextPromo">
                <div class="note note-info row ml-1 mt-3 p-4 col-sm-12 mb-3">

                    <div class="col-md-1">
                            <app-icon :name="'clock'" width="30" height="30"/>
                        </div>
                        <div class="col-md-11">
                            <b>{{ this.lockedScreenText }}</b><br> {{ $t('plan_expired_short') }}
                        </div>

                </div>
            </div>

            <div class="row row-full-width">
            <div v-if="this.payThis == 1" class="responsive-table-stretch pt-4 mt-2 col-sm-12">


                <div class="col-sm-12 col-md-3">
                    <h2 class="mb-3 text-left"><span v-if="this.lockedScreenTextHeader">{{ this.lockedScreenTextHeader }}<br></span>{{ this.$t('choose_membership') }}</h2>
                </div>

                <div class="col-sm-12 col-md-9">
                    <div class="col-sm-12 ml-md-5 mb-5 pr-0 p-0">
                        <ul class="checked-list text-left row">
                            <li class="col-md-4"><i class="custom-icon custom-icon-checked"></i>předplatné lze kdykoli zrušit</li>
                            <li class="col-md-3"><i class="custom-icon custom-icon-checked"></i>bez smlouvy a závazků</li>
                            <li class="col-md-5"><i class="custom-icon custom-icon-checked"></i>férová cena bez skrytých poplatků</li>
                        </ul>

                    </div>
                </div>


            </div>
            <div v-else-if="this.payThis == 2" class="box mt-2 col-sm-12 col-md-5">

                <h2 class="col-sm-12 mb-3 text-left">Feedback spokojenosti zaměstnanců</h2>
                <img src="/images/hp-slider-1.png" style="width:80%; margin: 0 auto">
                <div class="col-sm-12 mt-5">
                    <ul class="checked-list">
                        <li><i class="custom-icon custom-icon-checked"></i>sbírá lorem ipsum dolor</li>
                        <li><i class="custom-icon custom-icon-checked"></i>sbírá lorem ipsum dolor</li>
                        <li><i class="custom-icon custom-icon-checked"></i>lorem ipsum dolor</li>
                        <li><i class="custom-icon custom-icon-checked"></i>sbírá ipsum dolor</li>
                    </ul>
                    <br>
                    <a href="" target="_blank">Číst více na našem webu</a>
                </div>

            </div>

            <div v-if="this.payThis == 1" class="box mt-2 col-sm-12 col-md-12 pb-0">


                    <div class="text-center mt-4">

                        <h2>1. Vyberte funkce</h2><br>

                    </div>
                    <div class="responsive-table-stretch justify-content-center">


                            <div class="pricing-box-with-shadow highlighted-option col-sm-12 col-md-4">

                                <h5 class="mt-2"><b>Hiring</b></h5>
                                <ul class="lined-list">
                                    <li><app-icon :name="'anchor'" width="20" height="20" class="mr-3"/><b>Integrace</b> na všechny prac. portály</li>
                                    <li><app-icon :name="'globe'" width="20" height="20" class="mr-3"/>Vlastní <b>kariérní stránka</b></li>
                                    <li><app-icon :name="'thumbs-up'" width="20" height="20" class="mr-3"/>Časová osa, díky které máte přehled</li>
                                    <li><app-icon :name="'filter'" width="20" height="20" class="mr-3"/><b>Štítky,</b> filtrování, vyhledávání</li>
                                    <li><app-icon :name="'coffee'" width="20" height="20" class="mr-3"/>Šablony inzerátů a odpovědí</li>
                                    <li><app-icon :name="'feather'" width="20" height="20" class="mr-3"/><b>Poznámky</b> a hodnocení</li>
                                    <li><app-icon :name="'compass'" width="20" height="20" class="mr-3"/>GDPR ready, AI CV parser a další...</li>



                                </ul>
                                <div class="col-sm-12 text-center price mb-4">
                                    <del v-if="packageIs == 'hiring-and-onboarding'">1 000 Kč</del>
                                    <span v-if="packageIs == 'hiring-and-onboarding'">1 000 Kč </span>
                                    <span v-else-if="packageIs == 'onboarding'">1 000 Kč </span>
                                    <span v-else>1 000 Kč </span>
                                    <small> / měsíc</small>
                                </div>
                                <div class="col-sm-12 text-center pricing-box-button">

                                    <app-input  id="checkbox_notification"
                                                class="col-sm-12 mt-2"
                                                type="checkbox"
                                                :list="functionSelectionSmall"
                                                v-model="functionSmall"
                                                />

                                </div>
                            </div>
                            <div class="pricing-box-with-shadow highlighted-option col-sm-12 col-md-4">
                                <h5 class="mt-2"><b>Onboarding</b></h5>
                                <ul class="lined-list">
                                    <li><app-icon :name="'check-square'" width="20" height="20" class="mr-3"/><b>Checklist</b> pro HR i zaměstnance</li>
                                    <li><app-icon :name="'globe'" width="20" height="20" class="mr-3"/><b>Preboarding a onboarding</b> stránky</li>
                                    <li><app-icon :name="'filter'" width="20" height="20" class="mr-3"/><b>Štítky,</b> filtrování, vyhledávání</li>
                                    <li><app-icon :name="'feather'" width="20" height="20" class="mr-3"/><b>Poznámky</b> a hodnocení</li>
                                    <li><app-icon :name="'thumbs-up'" width="20" height="20" class="mr-3"/>Časová osa, díky které máte přehled</li>
                                    <li><app-icon :name="'compass'" width="20" height="20" class="mr-3"/>GDPR ready, analytika a další...</li>

                                </ul>
                                <div class="col-sm-12 text-center price mb-4">
                                    <del v-if="packageIs == 'hiring-and-onboarding'">5 500 Kč</del>
                                    <span v-if="packageIs == 'hiring-and-onboarding'">5 500 Kč </span>
                                    <span v-else-if="packageIs == 'onboarding'">5 500 Kč </span>
                                    <span v-else>5 500 Kč </span>
                                    <small> / měsíc</small>
                                </div>
                                <div class="col-sm-12 text-center pricing-box-button">

                                    <app-input  id="checkbox_notification"
                                                class="col-sm-12 mt-2"
                                                type="checkbox"
                                                :list="functionSelectionMedium"
                                                v-model="functionMedium"
                                                />

                                </div>
                            </div>




                        </div>
                        <div v-if="packageIs == 'hiring' || packageIs == 'onboarding'" class="text-muted text-center mt-3">Při objednání Hiring i Onboarding získáte <b>slevu 10%.</b></div>
                    </div>
            <div v-if="this.payThis == 1" class="box mt-2 col-sm-12 col-md-12 box-min-height pb-0">


                    <div v-if="this.functionSmall == 1 || this.functionMedium == 1" class="text-center mt-4">

                        <h2>2. Vyberte velikost firmy</h2><br>

                    </div>
                    <div v-if="this.functionSmall == 1 || this.functionMedium == 1" class="responsive-table-stretch">


                            <div class="pricing-box-with-shadow col-sm-12 col-md-4">

                                <h5 class="grey-icon"><br><b>1 HR</b></h5>
                                <div class="text-muted text-center col-sm-12 mb-4">
                                    Pro jednoho
                                </div>
                                <ul class="lined-list">
                                    <li>1 účet</li>
                                    <li class="package-hiring"><app-icon :name="'archive'" width="20" height="20" class="mr-2"/>Talentpool: 100 uchazečů</li>
                                    <li class="package-onboarding"><app-icon :name="'flag'" width="20" height="20" class="mr-2"/>Onboarding: 2 zam. najednou</li>
                                    <li>Neomezeně inzerátů a uchazečů</li>
                                    <li>E-mailová podpora</li>
                                </ul>
                                <div class="col-sm-12 text-center price mb-4">
                                    <del v-if="packageIs == 'hiring-and-onboarding'">800 Kč</del>
                                    <span v-if="packageIs == 'hiring-and-onboarding'">800 Kč </span>
                                    <span v-else-if="packageIs == 'onboarding'">800 Kč </span>
                                    <span v-else>800 Kč </span>
                                    <small> / měsíc</small>
                                </div>
                                <div class="col-sm-12 text-center pricing-box-button">

                                    <app-input  id="checkbox_notification"
                                                class="col-sm-12 mt-2"
                                                type="checkbox"
                                                :list="packageSelectionSmall"
                                                v-model="packageSmall"
                                                />

                                </div>
                            </div>
                            <div class="pricing-box-with-shadow highlighted-option col-sm-12 col-md-4">
                                <div class="text-center">
                                    <img src="/images/illustration-boats.svg" width="50%" class=" mt-4">
                                </div>
                                <h5><br><b>Malý tým</b></h5>
                                <div class="text-muted text-center col-sm-12 mb-3">
                                    <app-icon :name="'award'" width="20" height="20"/> <b>Nejoblíbenější</b>
                                </div>
                                <ul class="lined-list">
                                    <li>3 účty pro HR/liniové manažery</li>
                                    <li class="package-hiring"><app-icon :name="'archive'" width="20" height="20" class="mr-2"/>Talentpool: až 10 000  uchazečů</li>
                                    <li class="package-onboarding"><app-icon :name="'flag'" width="20" height="20" class="mr-2"/>Onboarding: až 7 zam. najednou</li>
                                    <li>Neomezeně inzerátů a uchazečů</li>
                                    <li>E-mailová podpora</li>
                                    <li>Chat</li>
                                </ul>
                                <div class="col-sm-12 text-center price mb-4">
                                    <del v-if="packageIs == 'hiring-and-onboarding'">4 000 Kč</del>
                                    <span v-if="packageIs == 'hiring-and-onboarding'">4 000 Kč </span>
                                    <span v-else-if="packageIs == 'onboarding'">4 000 Kč </span>
                                    <span v-else>4 000 Kč </span>
                                    <small> / měsíc</small>
                                </div>
                                <div class="col-sm-12 text-center pricing-box-button">

                                    <app-input  id="checkbox_notification"
                                                class="col-sm-12 mt-2"
                                                type="checkbox"
                                                :list="packageSelectionMedium"
                                                v-model="packageMedium"
                                                />

                                </div>
                            </div>
                            <div class="pricing-box-with-shadow col-sm-12 col-md-4">

                                <h5 class="red-icon"><br><b>Velký tým</b></h5>
                                <div class="text-muted text-center col-sm-12 mb-4">
                                    Pro větší týmy
                                </div>
                                <ul class="lined-list">
                                    <li>10 účtů pro HR/liniové manažery</li>
                                    <li class="package-hiring"><app-icon :name="'archive'" width="20" height="20" class="mr-2"/>Talentpool: <b>neomezený</b></li>
                                    <li class="package-onboarding"><app-icon :name="'flag'" width="20" height="20" class="mr-2"/>Onboarding: až 20 zam. najednou</li>
                                    <li>Neomezeně inzerátů a uchazečů</li>
                                    <li>E-mailová podpora</li>
                                    <li>Chat a telefonická podpora</li>
                                </ul>
                                <div class="col-sm-12 text-center price mb-4">
                                    <del v-if="packageIs == 'hiring-and-onboarding'">13 000 Kč</del>
                                    <span v-if="packageIs == 'hiring-and-onboarding'">13 000 Kč </span>
                                    <span v-else-if="packageIs == 'onboarding'">13 000 Kč </span>
                                    <span v-else>13 000 Kč </span>
                                    <small> / měsíc</small>
                                </div>
                                <div class="col-sm-12 text-center pricing-box-button">

                                    <app-input  id="checkbox_notification"
                                                class="col-sm-12 mt-2"
                                                type="checkbox"
                                                :list="packageSelectionLarge"
                                                v-model="packageLarge"
                                                />

                                </div>
                            </div>


                        </div>
                        <div v-else class="text-center mt-5">

                            <h2>Pro pokračování nejprve vyberte funkce</h2><br>

                        </div>

<br>
                    <h1 v-if="this.totalPrice && (this.packageSmall == 1 || this.packageMedium == 1 || this.packageLarge == 1)" class="text-center">Celkem {{ this.totalPrice }} Kč / měsíc</h1>
                    <div class="w-100 col-sm-12 mt-2 mb-3 text-center text-muted">
                        <p>
                            <br>
                            <b>Individuální potřeby?</b> Jsme tu pro vás, napište nám na ahoy@onboardio.cz. <br>Rádi Vás vyslechneme a bude-li to v našich silách, připravíme pro vás řešení na míru.
                        </p>
                    </div>
            </div>
            <div v-if="this.payThis == 1 && (this.packageSmall == 1 || this.packageMedium == 1 || this.packageLarge == 1) && (this.functionSmall == 1 || this.functionMedium == 1)" class="w-100 col-sm-12 text-center mt-5 pr-0 pl-4">

                <h2>3. Vyplňte fakturační údaje</h2><br>

                <div class="note note-silver">
                    <iframe src="https://form.fapi.cz/?id=0c13a4ce-2a66-4753-ad66-2f89f7234421" width="100%" height="1300" frameBorder="0"></iframe>
                </div>

                <div class="col-sm-12 offset-md-2 col-md-8 mt-4 mb-3 pt-4 pb-4 text-center text-muted">
                    <p>
                        S údaji Tvé platební karty nakládá GoPay podle mezinárodního bezpečnostního standardu PCI-DSS Level 1. <b>Jedná se o nejvyšší úroveň datové bezpečnosti</b> ve finančním sektoru.<br>
                        <img src="/images/gopay-payment-logos.png" style="width: 50%;">
                    </p>


                </div>

            </div>
            <div v-else-if="this.functionSmall == 1 || this.functionMedium == 1" class="box col-sm-12 text-center mt-2">

                <h2>Pro pokračování vyberte nejprve velikost firmy</h2><br>

            </div>
            <div v-if="this.payThis == 2" class="box text-center mt-2 col-sm-12 offset-md-1 col-md-5">

                <div class="form-group row align-items-center mb-5">
                    <p class="mt-4">
                        platebni brana / FAPI
                    </p>



                    <div class="col-sm-12 text-center">
                        <button class="btn btn-primary mt-3" @click.prevent="confirmDemoDelete()">{{ $t('trial_period_ended_buy_button') }}</button>
                    </div>

                </div>

            </div>

            </div>
            <div class="clearfix"></div>

        </template>
    </modal>
</template>

<script>
    import {FormMixin} from '../../../../../../core/mixins/form/FormMixin.js';
    import {ModalMixin} from "../../../../../Mixins/ModalMixin";
    import {UserMixin} from "../../../../../../app/Components/Views/Auth/Mixins/UserMixin";
    import AppLibrary from "../../../../../Helpers/AppLibrary";

    export default {
        name: "PayModal",
        extends: AppLibrary,
        mixins: [FormMixin, ModalMixin, UserMixin],
        props: {
            tableId: String,
            selectedRows: Array,
            modalType: String,
            selectedUrl: Array,
        },
        data() {
            return {
                preloader: false,
                packageIs: 'hiring-and-onboarding',
                lockedScreenText: '',
                lockedScreenTextHeader: '',
                lockedScreenTextPromo: false,
                totalPrice: 0,

                inputs: {
                    name: '',
                    job: '',
                    sendTo: '',
                    status: '2',

                },
                modalId: 'pay-Modal',
                modalTitle: this.$t('add'),

                packageSmall: '',
                packageMedium: '',
                packageLarge: '',
                packageSelectionSmall: [
                    {id: '1', value: this.$t('i_want_this_button')},
                ],
                packageSelectionMedium: [
                    {id: '1', value: this.$t('i_want_this_button')},
                ],
                packageSelectionLarge: [
                    {id: '1', value: this.$t('i_want_this_button')},
                ],

                functionSmall: ["1"],
                functionMedium: ["1"],
                functionSelectionSmall: [
                    {id: '1', value: this.$t('i_want_this_button')},
                ],
                functionSelectionMedium: [
                    {id: '1', value: this.$t('i_want_this_button')},
                ],


                value: {},
                tagPreloader: false,
                multiCreatePreloader: false,
            }
        },

        watch: {
            packageSmall: {
              handler (val, oldVal) {
                    if(val == 1){
                        this.packageLarge = [];
                        this.packageMedium = [];
                    }

                    this.calculatePrice();
                }
            },
            packageMedium: {
              handler (val, oldVal) {
                      if(val == 1){
                          this.packageLarge = [];
                          this.packageSmall = [];
                      }

                      this.calculatePrice();
                  }
            },
            packageLarge: {
                handler (val, oldVal) {
                        if(val == 1){
                            this.packageSmall = [];
                            this.packageMedium = [];
                        }

                        this.calculatePrice();
                    }
            },
            functionSmall: {
              handler (val, oldVal) {
                    if(this.functionMedium == 1 && val == 1){
                      this.showPackageHiringAndOnboarding();
                      console.log('test55');
                    } else if(this.functionSmall == 1){
                        this.showPackageHiring();
                    } else if(this.functionMedium == 1){
                        this.showPackageOnboarding();
                    } else  {
                        //this.showPackageHiring();
                    }

                    this.calculatePrice();
                }
            },
            functionMedium: {
              handler (val, oldVal) {
                  if(val == 1 && this.functionSmall == 1){
                      this.showPackageHiringAndOnboarding();
                      console.log('test55');
                  } else if(this.functionSmall == 1){
                      this.showPackageHiring();
                  } else if(this.functionMedium == 1){
                      this.showPackageOnboarding();
                  } else {
                      //this.showPackageHiring();
                  }

                  this.calculatePrice();
                }
            },
        },

        created() {
            if (this.selectedUrl) {
                this.preloader = true;
                console.log(this.selectedUrl);
            }

            this.getDefaultPay();
            this.isMembershipPaid();

        },
        mounted() {
            this.animatePrice();

            // Disable after enabling fapi
            this.payThis = 0;

            $('.pricing-box-with-shadow:eq(0)').delay(100).fadeIn();
            $('.pricing-box-with-shadow:eq(1)').delay(700).fadeIn();
            $('.pricing-box-with-shadow:eq(2)').delay(1300).fadeIn();
            $('.pricing-box-with-shadow:eq(3)').delay(100).fadeIn();
            $('.pricing-box-with-shadow:eq(4)').delay(700).fadeIn();
            $('.pricing-box-with-shadow:eq(5)').delay(1300).fadeIn();
            $('.below-pricing-box').delay(1800).fadeIn();

        },
        methods: {
            calculatePrice(){
                let totalPrice = 0;
                if(this.functionSmall == 1){
                    totalPrice += 1000;
                }
                if(this.functionMedium == 1){
                    totalPrice += 5500;
                }
                if(this.packageSmall == 1){
                    totalPrice += 800;
                } else if(this.packageMedium == 1){
                    totalPrice += 4000;
                } else if(this.packageLarge == 1){
                    totalPrice += 13000;
                }

                this.totalPrice = totalPrice;

                // + sleva 10%
            },
            getUrlParameter(name, url) {
                if (!url) url = location.href;
                name = name.replace(/[\[]/,"\\\[").replace(/[\]]/,"\\\]");
                var regexS = "[\\?&]"+name+"=([^&#]*)";
                var regex = new RegExp( regexS );
                var results = regex.exec( url );
                return results == null ? null : results[1];
            },
            getDefaultPay(){
                let selectedModule = '';

                if(location.href.indexOf("?pay") >= 0){
                    selectedModule = parseInt(this.getUrlParameter('pay', location.href));
                }

                this.payThis = selectedModule;
            },
            showPackageHiring() {
                this.packageIs = 'hiring';
                $('.package-onboarding').slideUp();
                $('.package-hiring').delay(250).slideDown();

                $('.package-onboarding-fade, .package-hiring-onboarding-fade').hide();
                $('.package-hiring-fade').delay(250).show();
            },
            showPackageOnboarding() {
                this.packageIs = 'onboarding';
                $('.package-hiring').slideUp();
                $('.package-onboarding').delay(250).slideDown();
                $('.package-hiring-fade, .package-hiring-onboarding-fade').hide();
                $('.package-onboarding-fade').delay(250).show();
            },
            showPackageHiringAndOnboarding() {
                this.animatePrice();
                this.packageIs = 'hiring-and-onboarding';
                $('.package-hiring, .package-onboarding').delay(500).slideDown();
                $('.package-hiring-fade, .package-onboarding-fade, .package-hiring-onboarding-fade').delay(500).show();
            },
            animatePrice() {
                const counters = document.querySelectorAll('.number-animate');
                const speed = 550;

                counters.forEach( counter => {
                   const animate = () => {
                      const value = +counter.getAttribute('data-number');
                      const data = +counter.innerText;

                      const time = value / speed;
                        if(data < value) {
                          counter.innerText = Math.ceil(data + time);
                          setTimeout(animate, 1);
                        } else {
                          counter.innerText = value;
                        }

                   }

                   animate();
                });
            },


            /**
            * Membership
            */
            isMembershipPaid() {
                this.trialMode = true;
                this.daysRemaining = 30;

                // Get date to and count remaining days
                let url = '/membership';

                this.axiosGet(url).then(response => {

                    var membershipData = response.data;

                    let paidUntil = '';
                    let trialUntil = '';
                    let todaysDate = new Date();
                    var dateFormatted = todaysDate.getFullYear()+'-'+(todaysDate.getMonth()+1)+'-'+todaysDate.getDate();

                    if(membershipData[0].paid_until !== null){
                         paidUntil = new Date(membershipData[0].paid_until);
                    }

                    if(membershipData[0].trial_until !== null){
                         trialUntil = new Date(membershipData[0].trial_until);
                    }

                    let isMembershipPaid = moment(todaysDate).isBefore(paidUntil);
                    let isTrialActive = moment(todaysDate).isBefore(trialUntil);

                    if(isMembershipPaid){
                        console.log('membership '+dateFormatted+' isBefore exp '+membershipData[0].paid_until);
                    } else if (isTrialActive){
                        console.log('trial '+dateFormatted+' isBefore exp '+membershipData[0].trial_until);
                        let trialLeft = moment(trialUntil).diff(moment(todaysDate), 'days')+1;
                    } else {

                        if(membershipData[0].paid_until){
                            this.lockedScreenTextHeader = 'Členství vypršelo.';

                        } else {
                            this.lockedScreenTextHeader = 'Zkušební verze vypršela.';
                        }

                        this.showLockedScreen = true;

                        $('body').append('<div class="trial-note text-center note note-silver pt-5 pb-5 mt-4 row"><div class="offset-3 col-6"><b>body.membership-locked'+this.$t('last_days_of_your_trial_first_part')+' '+trialLeft+' '+this.$t('last_days_of_your_trial')+'</b><br>Vyberte si balíček ať můžete Onboardio využívat i po uplynutí zkušební doby.</div><div class="col-3"><a href="?pay=1" class="ml-md-3 ml-sm-0 mb-sm-4 mb-md-0 mt-2 mt-md-0 btn btn-primary">'+this.$t('buy_onboardio')+'</a></div></div>');
                        console.log('membership not ok '+isMembershipPaid+' '+isTrialActive);
                        // lock with button pay on all pages (add html via jquery) body.append
                    }
                }).catch(({response}) => {

                }).finally(() => {

                });
            },

            beforeSubmit() {
              this.preloader = true;
            },
            submit() {

                // Axios PATCH, add candidates flag "talentpool"


                // Send mail to candidates


            },
            afterSuccess(response) {
                this.$toastr.s(response.data.message);
                this.$hub.$emit('reload-' + this.tableId);

            },
            afterSuccessFromGetEditData(response) {

                this.preloader = false;

            },
            afterError(res) {
              this.$toastr.e(res.data.message);

            },
            clear() {
              this.inputs = {};
            },

        },
    }
</script>
